import { orgAdmin } from './instance'

const baseUrl = (orgId) => `/${orgId}/shopBenefitSharing`

/**
 * 取得總部分店資訊 orgAdmin.shopBenefitSharing.findHeadquarter
 * @param {Object} params - 查詢參數
 * @param {string} params.orgId - 組織ID
 * @returns {Promise<Object>} 總部分店資訊
 * @example
 * // 回傳格式
 * {
 *   hasHeadquarter: true,
 *   shopId: 'shop-id',
 *   shopName: '總部分店名稱'
 * }
 */
export const GetShopBenefitSharingHeadquarter = async ({ orgId }) => {
  return await orgAdmin({
    method: 'GET',
    url: `${baseUrl(orgId)}/headquarter`,
  })
}

/**
 * 設定總部分店 orgAdmin.shopBenefitSharing.setHeadquarter
 * @param {Object} params - 設定參數
 * @param {string} params.orgId - 組織ID
 * @param {string} params.shopId - 分店ID
 * @returns {Promise<Object>} 設定結果
 */
export const SetShopBenefitSharingHeadquarter = async ({ orgId, shopId }) => {
  return await orgAdmin({
    method: 'POST',
    url: `${baseUrl(orgId)}/setHeadquarter`,
    data: {
      shopId,
    },
  })
}
